import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import bem from '../../../lib/bemUtils/bem';

export enum TileContainerModifier {
  BOX_SHADOW = 'box-shadow',
  SLIM = 'slim',
  IMAGE_TOP = 'image-top',
}

type TileContainerProps = {
  modifier?: Modifier<TileContainerModifier>;
} & PropsWithChildren;

export function Tile({ children, modifier }: TileContainerProps) {
  return (
    <li className={bem('tiles__tile', modifier)} tabIndex={-1}>
      {children}
    </li>
  );
}
